export default "__VITE_ASSET__CRD$js0o__"